/*
# -----------------------------------------------------------------------------
# Component: marineDataMixin.js
# Author: ssy@pst.sg
# Created Date: 20/Feb/2020
# Comments: Responsible for shared components - Policy Type Parameters
# -----------------------------------------------------------------------------
*/

import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const marineDataMixin = {
  data() {
    return {
      sideFunction: [
        {
          text: 'Vessel Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslCls' }
        },
        {
          text: 'Vessel Construction',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslConstn' }
        },
        // {
        //   text: 'Vessel Detail',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'vslDet' }
        // },
        {
          text: 'Vessel Engine Make',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslEngMake' }
        },
        {
          text: 'Vessel Engine Model',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslEngMod' }
        },
        {
          text: 'Vessel Flag',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslFlag' }
        },
        {
          text: 'Vessel Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslType' }
        }
        // {
        //   text: 'Vessel Voyage',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'vslVoy' }
        // }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.vesselParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramType: result.paramType,
                paramDesc: result.paramDesc,
                estDeptDate: result.estDeptDate
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.marineParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
